<template>
    <v-container class="py-0">
        <v-row v-if="solidDisk">
            <v-col cols="12" class="mb-0 pb-0">
                <v-btn-toggle
                        v-model="diskClass"
                        dense
                        mandatory
                        background-color="primary"
                        class="change_dtype mt-2 mb-3"
                >
                    <v-btn v-for="(classname, index) in diskClassList" :key="index" @click="checkType(index)">
                        <span class="hidden-sm-and-down">{{classname}}</span>
                    </v-btn>

                </v-btn-toggle>
            </v-col>
            <v-col cols="6" class="mt-0 pt-0">
                <v-switch v-model="eightRepair" inset label="Восьмерка" color="success" hide-details class="mt-1"></v-switch>
            </v-col>
            <v-col cols="6" class="mt-0 pt-0">
                <v-switch v-model="premium" inset label="Премиум" color="success" hide-details class="mt-1" :disabled="premiumOff"></v-switch>
            </v-col>
            <v-col cols="12" class="my-0 py-1" v-for="item in diskDamage" :key="item.id">
                <v-btn class="mr-6" :data-test-id="'addDamageItem_'+item.id" :class="item.active?'active':''" @click="diskDamageSet({id:item.id, value:!item.active, item:'active', side:side})">
                    {{item.id}}
                </v-btn>
                <span v-if="item.active">
                     <v-btn small class="rbordernone" :class="!item.inside?'active':''" @click="diskDamageSet({id:item.id, value:false, item:'inside', side:side})">
                        снаружи
                    </v-btn>
                    <v-btn small class="lbordernone" :class="item.inside?'active':''" @click="diskDamageSet({id:item.id, value:true, item:'inside', side:side})">
                        внутри
                    </v-btn>
                    <span class="btn-descr body-2 font-weight-light">
                        размер
                        повреждения, мм:
                        <v-chip
                            v-if="item.size>2"
                            class="ma-2 titlechip"
                            color="orange"
                            text-color="indigo darken-4"
                            outlined
                            x-small
                            label
                        >
                            {{ item.size>2 ? item.size>4 ? '+' + hugeDamage.price + '₽ ' + hugeDamage.name : '+' + bigDamage.price + '₽ ' + bigDamage.name: '' }}
                        </v-chip>
                    </span>
                    <v-btn @click="item.size==1?'':diskDamageSet({id:item.id, value:item.size-1, item:'size', side:side})" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                        {{ item.size }}
                    <v-btn data-test-id="addSizeDamage" @click="diskDamageSet({id:item.id, value:item.size+1, item:'size', side:side})" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn>

                </span>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="6">
                <v-switch v-model="eightRepair" inset label="Восьмерка" color="success" hide-details class="mt-1"></v-switch>
                <v-switch v-model="edgeRepair" inset label="Ремонт кромки диска" color="success" hide-details class="mt-1"></v-switch>
            </v-col>
            <v-col cols="6">
                <v-switch
                        v-model="addRepair"
                        inset
                        label="Ручной ремонт, шт"
                        color="success"
                        hide-details
                        class="mt-2 mb-2"
                ></v-switch>
                <span v-if="addRepair">
                    <v-btn @click="addRepairNumbr==1?'':addRepairNumbr--" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                    {{ addRepairNumbr }}
                    <v-btn @click="addRepairNumbr++" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn><span class="addpricetext"></span>
                </span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'diskRoptions',
        props: ['side', 'source', 'hugeDamage', 'bigDamage' ],
        computed: {
            diskClass: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.diskClass
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'diskClass', value })
                }
            },
            eightRepair: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.eightRepair
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'eightRepair', value })
                }
            },
            premium: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.premium
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'premium', value })
                }
            },
            edgeRepair: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.edgeRepair
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'edgeRepair', value })
                }
            },
            addRepair: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.addRepair
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'addRepair', value })
                }
            },
            addRepairNumbr: {
                get() {
                    return this.$store.state[this.source].wheels[this.side].data.addRepairNumbr
                },
                set(value) {
                    this.$store.commit(this.source + '/setPlus', { side: this.side, item: 'addRepairNumbr', value })
                }
            },
            solidDisk() {
                return this.$store.state[this.source].wheels[this.side].data.solidDisk
            },
            diskDamage() {
                return this.$store.state[this.source].wheels[this.side].data.diskDamage
            },
        },
        data () {
            return {
                premiumOff: false,
                diskClassList: ['Стандарт', 'Реплика', 'Кованный'],
            }
        },
        methods: {
            checkType(type){
                if(type==1){
                    this.premium = false
                    this.premiumOff = true
                } else {
                    this.premiumOff = false
                }
            },
            diskDamageSet(x){
                if((x.id != 1 && x.item == 'active')||x.item != 'active'){
                    this.$store.commit('diskrepair/diskDamageSet', x)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .titlechip{
        position: absolute;
        left: -7px;
        top: 14px;
        padding: 2px;
    }
    .active {
        background-color: #FFFBCD !important;
    }
    .btn-descr {
        margin-left: 12px;
        top: 1px;
        display: inline-flex;
        position: relative;
        width: 176px;
        background-color: #fffccc;
    }
    .rbordernone {
        border-top-right-radius: 0!important;
        border-bottom-right-radius: 0 !important;
    }
    .lbordernone {
        border-top-left-radius: 0!important;
        border-bottom-left-radius: 0 !important;
    }
    .addpricetext {
        color: forestgreen;
        font-weight: bold;
        padding-left: 15px;
    }
    .border {
        border-radius: 4px;
        border: thin solid rgba(0,0,0,.12);
    }
    .primary_bg_color {
        background-color: #FFFEEE !important;
    }
    .primary_bg_color .active {
        background-color: #FFFBCD !important;
    }
    .change_disk.v-btn-toggle .v-btn{
        height: 51px !important;
        width: 80px !important;
    }
    .change_disk.v-btn-toggle{
        height: 51px !important;
        width: 80px !important;
    }
    .tabs_icons_big {
        width: 40px;
        height: 40px;
    }
</style>
